import type { ChartPoint } from '../ColumnChart/chart-point.ts';
import { SeriesTable } from '../Chart/SeriesTable.tsx';

export type ChartTableProps = { label: string; points: readonly ChartPoint[] };

export const ChartTable = ({ label, points }: ChartTableProps) => (
  <SeriesTable label={label} series={[{ key: 'value', label, points }]} />
);
